/** Keep private measurement requests out of external error and performance reporting. */
const SEARCH_TELEMETRY_PATH = /\/(?:api\/)?(?:public\/search(?:[/?#]|$|-analytics)|admin\/(?:search-analytics|analytics\/searches)(?:[/?#]|$)|public\/company-statistics(?:[/?#]|$)|privacy\/company-analytics(?:[/?#]|$))/i;

const containsSearchTelemetry = (value: unknown, depth = 0): boolean => {
  if (typeof value === 'string') {
    return SEARCH_TELEMETRY_PATH.test(value);
  }
  if (!value || typeof value !== 'object' || depth > 8) {
    return false;
  }
  return Object.entries(value).some(([key, entry]) => {
    return /^x-company-statistics-/i.test(key) || containsSearchTelemetry(entry, depth + 1);
  });
};

/** A generic serialization boundary, deliberately independent of a monitoring SDK. */
export const filterSearchTelemetry = <T>(event: T): T | null => {
  if (!event || typeof event !== 'object') {
    return event;
  }

  const record = event as Record<string, unknown>;
  const { breadcrumbs, spans, ...context } = record;
  if (containsSearchTelemetry(context)) {
    return null;
  }

  const filtered = { ...record };
  if (Array.isArray(breadcrumbs)) {
    filtered['breadcrumbs'] = breadcrumbs.filter((entry) => {
      return !containsSearchTelemetry(entry);
    });
  }
  if (Array.isArray(spans)) {
    filtered['spans'] = spans.filter((entry) => {
      return !containsSearchTelemetry(entry);
    });
  }
  return filtered as T;
};

export const filterSearchBreadcrumb = <T>(breadcrumb: T): T | null => {
  if (containsSearchTelemetry(breadcrumb)) {
    return null;
  }
  return breadcrumb;
};
